<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">

       <el-form :inline="true" class="sellsearch backborder1 demo-form-inline" size="small" :style="issearchshow ? searchshow : searchhide">			
          <!-- 时间 -->
          <el-form-item style="width:12%">
              <el-date-picker v-model="query.starttime" type="date" @change="ischange=true" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择开始日期" style="width:100%"></el-date-picker>
          </el-form-item>
          <el-form-item style="width:12%">
              <el-date-picker v-model="query.endtime" type="date" @change="ischange=true" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择结束日期" style="width:100%"></el-date-picker>
          </el-form-item>

          <!-- 商品出处 -->
          <el-form-item size="small" style="width:8%">
    			    <el-select v-model="query.goodstype" clearable remote @change="ischange=true"  placeholder="商品来源">
		          	  <el-option v-for="(item,index) in goodstypelists" :key="index" :label="item.name" :value="item.id"></el-option>
		          </el-select> 
    		  </el-form-item>

          <!-- 品牌 -->
          <el-form-item style="width:13%">
		          <el-select v-model="query.brandid" filterable clearable @change="ischange=true" placeholder="按品牌" >
		              <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
		              	  <span style="float: left">{{item.name}}</span>
      				        <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
		              </el-option>
		          </el-select>
	        </el-form-item>

          <!-- 销售员 -->
          <el-form-item size="small" style="width:11%" v-if="userlists.length > 0">
    			    <el-select v-model="query.userid" clearable filterable remote @change="ischange=true" placeholder="销售员" style="width:100%">
		          	  <el-option v-for="(item,index) in userlists" :key="index" :label="item.name" :value="item.id"></el-option>
		          </el-select> 
    		  </el-form-item>

          <!-- 关键字搜索类型 -->
          <el-form-item size="small" style="width:12%">
    			    <el-select v-model="query.keytype" placeholder="关键字搜索类型" @change="changekeytype" style="width:100%">
		          	  <el-option v-for="(item,index) in keytypelists" :key="index" :label="item.name" :value="item.id"></el-option>
		          </el-select> 
    		  </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="exportdata">导出</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="success" icon="el-icon-arrow-up" circle v-if="issearchshow" @click="hideandshow"></el-button>
              <el-button type="success" icon="el-icon-arrow-down" circle v-if="!issearchshow"  @click="hideandshow"></el-button>
          </el-form-item>
          
          <el-col :span="24">
          <el-form-item size="small" style="width:16%">
              <el-select v-model="query.keyid" clearable filterable remote reserve-keyword :remote-method="getkeylists" :loading="keyloading" @change="changekeyid" placeholder="关键字" style="width:100%">
                  <el-option v-for="(item,index) in keylists" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select> 
          </el-form-item>
          <el-form-item style="width:15%" v-if="speclists.length>0">
              <el-select v-model="query.propertyid" clearable placeholder="规格" @change="ischange=true" style="width:100%">
		          	  <el-option v-for="(item,index) in speclists" :key="index" :label="item.name" :value="item.id"></el-option>
		          </el-select> 
			    </el-form-item>
          </el-col>
      </el-form>

      <el-tag type="danger" closable  @close="closetag" v-if="tagshow" style="margin-top:10px">温馨提示：此处的销售员为宠老板门店系统的销售员，而非宠赞系统的</el-tag>
      
      <div class="backborder2" style="margin-top:10px">
	    	<el-table :data="lists" v-loading="listloading">
		        <el-table-column label="订单编号" prop="ordernumber" width="80"></el-table-column>
		        <el-table-column label="商品名称" prop="name"></el-table-column>
		        <el-table-column label="品牌" prop="brandname" align="left" width="95"></el-table-column>
		        <el-table-column label="销售员" prop="username" align="left" width="80"></el-table-column>
		        <el-table-column label="规格" prop="spec" align="center" width="110"></el-table-column>
		        <el-table-column label="价格" prop="price" align="center" width="110"></el-table-column>
		        <el-table-column label="数量" prop="num" align="center" width="90"></el-table-column>
		        <el-table-column label="小计" prop="total" align="center" width="100"></el-table-column>
                <el-table-column label="时间" prop="inputtime" align="center" width="140"></el-table-column>
                <el-table-column label="来源" prop="type" align="center" width="90">
                    <template slot-scope="scope">
		        		<el-tag type="success" v-if="scope.row.type==1">宠赞</el-tag>
		        		<el-tag type="danger" v-if="scope.row.type==2">京东</el-tag>
		        	</template>
                </el-table-column>
	        </el-table>
            <div class="block">
	        	<!--分页begin-->
	            <el-pagination
		            @size-change="orderPageSizeChange"
		            @current-change="orderPageCurrentChange"
		            :current-page="query.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="query.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="lists_rows">
	            </el-pagination>
	            <!--分页end-->
	      	</div>
        </div>

        <!--------- 按客户导出信息 ------------>
	    <el-dialog title="导出商品销售记录确认" :visible.sync="exportDialog" width="98%" top="5vh">
	      	<el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="exportlists" border v-loading="exportloading">
		      	  	<el-table-column label="订单编号" prop="ordernumber" width="80"></el-table-column>
                    <el-table-column label="商品名称" prop="name"></el-table-column>
                    <el-table-column label="品牌" prop="brandname" align="left" ></el-table-column>
                    <el-table-column label="销售员" prop="username" align="left"></el-table-column>
                    <el-table-column label="规格" prop="spec" align="center"></el-table-column>
                    <el-table-column label="价格" prop="price" align="center"></el-table-column>
                    <el-table-column label="数量" prop="num" align="center" ></el-table-column>
                    <el-table-column label="小计" prop="total" align="center" ></el-table-column>
                    <el-table-column label="时间" prop="inputtime" align="center" ></el-table-column>
                    <el-table-column label="来源" prop="showtype" align="center" ></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="exportDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>

	</div>
    </transition>
</template>

<script>
export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Mallstat/index",
      transitionshow:true,
      actionauth:[],
	  query: {
          act:'getselllists',
          token:this.$cookies.get('token'),
          starttime:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
          endtime:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
          userid:'',
          goodstype:'',
          brandid:'',
          keytype:1,
          keyid:'', //keytype为1时是订单id，keytype为2时为商品id
          propertyid:'',
          p:1,
          rollpage:10
	  },
      goodstypelists:[{id:1,name:'宠赞'},{id:2,name:'京东'}],
      keytypelists:[{id:1,name:'按订单编号'},{id:2,name:'按商品名称/sku'}],
      lists:[],
      brandlists:[],
      speclists:[],
      userlists:[],
      issearchshow: false,
      listloading:false,
      searchhide: {height:'3rem'},
      searchshow: {height:'6.5rem'},
      tagshow:true,
      keyloading:false,
      keylists:[],
      lists_rows:0,
      exportDialog:false,
      exportloading:false,
      exportlists:[],
      ischange:false,

    }
  },
  mounted(){    
  	  this.getactionauth(); //获取权限设置
      this.getBrand(); //获取品牌信息
      this.getuserlists(); //获取宠老板销售员信息
      this.getList(); //获取商品信息
  },

  methods:{
    
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

    /** 展开，收起搜索栏 **/
    hideandshow() {
        this.issearchshow==false ? this.issearchshow=true : this.issearchshow=false;
    },

    /** 获取销售记录信息 **/
    getList() {
        if(this.ischange==true) {
            this.query.p=1;
            this.query.rollpage=10;
        }

        this.listloading=true;
        var resource = this.$resource(this.url);
	    resource.query(this.query).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
                this.listloading=false;
		    }else{
		        this.lists = JSON.parse(Base64.decode(res.data.Data));
                this.lists_rows=parseInt(res.data.count);
                this.listloading=false;
                if(this.ischange==true) this.ischange=false;
		    }
	    }).catch((res) => {
	        this.listloading=false;
	    });
    },

    orderPageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    orderPageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },

    /** 获取品牌信息数据 **/
	  getBrand(){
	      var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
	      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		        	var _this=this;
		            var result = JSON.parse(Base64.decode(res.data.Data));
		            this.brandlists=[];
		            result.forEach(function(e,i) {
		            	_this.brandlists.push({id:e.id,name:e.name,py:e.py,showlable:e.showlable});
		            });
		        }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
	  },

    /** 获取宠老板销售员信息 **/
    getuserlists() {
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
	      resource.query({act:'getclbusers',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.userlists = JSON.parse(Base64.decode(res.data.Data));
		        }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
    },

    /** 获取关键字搜索信息列表 **/
    getkeylists(val) {
        this.keyloading=true;
        var resource = this.$resource(this.url);
	      resource.query({act:'findorderorgoods',token:this.$cookies.get('token'),key:val,type:this.query.keytype}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
                this.keyloading=false;
		        }else{
		            this.keylists = JSON.parse(Base64.decode(res.data.Data));
                this.keyloading=false;
		        }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
            this.keyloading=false;
	      });
    },


    closetag() {
        this.tagshow=false;
    },

    /** 切换关键字搜索类型 **/
    changekeytype() {
        this.ischange=true;
        this.query.keyid='';
        this.query.propertyid='';
        this.keylists=[];
        this.speclists=[];
    },

    /** 关键字变更 **/
    changekeyid() {
        this.ischange=true;
        //搜索商品成功时联动搜索商品的规格信息
        if(this.query.keytype==2) {
            this.speclists=[];
            this.query.propertyid='';
            var resource = this.$resource(this.url);
	        resource.query({act:'findgoodsproperty',token:this.$cookies.get('token'),keyid:this.query.keyid}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.speclists = JSON.parse(Base64.decode(res.data.Data));
		        }
	        }).catch((res) => {

	        });
        }
    },


    /** 导出销售记录 **/
    exportdata() {
        this.exportDialog=true;
        this.exportloading=true;
        var resource = this.$resource(this.url);
	    resource.query({act:this.query.act,token:this.query.token,starttime:this.query.starttime,endtime:this.query.endtime,userid:this.query.userid,goodstype:this.query.goodstype,brandid:this.query.brandid,keytype:this.query.keytype,keyid:this.query.keyid,propertyid:this.query.propertyid,p:1,rollpage:100000000}).then((res) => {
		    if(res.data.Result>0){
		        if(res.data.Result=='70001') this.$router.push('/login')
		        this.$message.error(res.data.Message);
                this.exportloading=false;
		    }else{
		        this.exportlists = JSON.parse(Base64.decode(res.data.Data));
                this.exportloading=false;
		    }
	    }).catch((res) => {
	        this.exportloading=false;
	    });
    },

    /** 确认导出订单信息 **/
    sureoutput() {
		require.ensure([], () => {
			var { export_json_to_excel } = require('../../vendor/Export2Excel');
			var tHeader = ['订单编号','商品名称','品牌','销售员','规格','价格','数量','小计','时间','来源'];
			var filterVal = ['ordernumber','name','brandname','username','spec','price','num','total','inputtime','showtype'];
				
			var list = this.exportlists;
			var data = this.formatJson(filterVal, list);
			export_json_to_excel(tHeader, data, '线上商城销售记录');
			this.exportDialog=false;
		})
    },
    
    //导出表格数据
	formatJson(filterVal, jsonData) {
　　　　return jsonData.map(v => filterVal.map(j => v[j]));
　　},
    

  }
}
</script>

</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.sellsearch {overflow:hidden;transition: all .3s}
</style>


// WEBPACK FOOTER //
// src/components/stat/mallsellstats.vue